<!--绑定邮箱-->
<template>
  <div class="bind-email-container" :style="'min-height:'+min_height+'px;'">
    <div class="bind-content">
      <!--已绑定邮箱-->
      <div class="bind-email" v-if="bindInfo.emailStatus==1">
        <p class="title SourceHanSansCN">已绑定邮箱</p>
        <p class="bigger-title SourceHanSansCN">{{ parseStringToStar(bindInfo.email) }}</p>
        <p class="gray-tips SourceHanSansCN">绑定邮箱作为您的身份验证的重要方式，请谨慎操作</p>
        <el-button type="danger" @click="UnbindEmail">解除绑定</el-button>
      </div>
      <!--未绑定邮箱-->
      <div class="un-bind-email" v-else>
        <p class="title SourceHanSansCN">请绑定邮箱</p>
        <el-form label-position="top" :model="bindForm" status-icon :rules="rules" ref="bindForm" class="demo-ruleForm"
                 style="width: 45%" :hide-required-asterisk="true">
          <el-form-item label="邮箱账号" prop="email">
            <el-input v-model="bindForm.email" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="邮箱验证码" prop="code">
            <el-input v-model="bindForm.code" placeholder="请输入验证码" style="width: 75%;"/>
            <el-button @click="getCode" v-show="flag" type="text" style="width: 102px;" class="get-code">获取验证码
            </el-button>
            <el-button type="text" disabled v-show="!flag" style="width: 102px;">剩余{{ second }}s</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="bindEmail">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

import {accountManage} from "@/api/systemSetting";
import {sendEmailVerCode,checkEmailVerCode,bindMailbox,untieMailbox} from "@/api/currencyApi";

export default {
  name: "bindEmail",
  data() {
    // 验证邮箱
    let checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('邮箱不能为空!'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('邮箱格式错误!'))
        }
      }, 100)
    }
    return {
      bindInfo: {
        email: '',
        accountSecurityScore: 0,
        emailStatus: 0,
        idenitityNum: "",
        loginDevice: null,
        loginProtectStatus: null,
        loginPwd: "",
        loginPwdStatus: 0,
        mobile: "",
        nikeName: "",
        realName: "",
        verifiedStatus: 0
      },
      bindForm: {
        email: '',
        code: '',
      },
      rules: {
        email: [
          {required: true, validator: checkEmail, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码!', trigger: 'blur'},
        ]
      },
      flag: true,
      second: 300,
      timer: null, // 该变量是用来记录定时器的,防止点击的时候触发多个setInterval
      min_height: document.documentElement.clientHeight - 346,
      uid: 0,
    }
  },
  methods: {
    /*获取验证码*/
    getCode() {
      let that = this;
      if (that.flag) {
        sendEmailVerCode({email: that.bindForm.email, steps: "绑定邮箱", uid: that.uid,request: 'form'}).then(res => {
          if (res.code == 200) {
            this.$message.success('验证码已发送');
            that.flag = false;
            let interval = window.setInterval(function () {
              that.setStorage(that.second);
              if (that.second-- <= 0) {
                that.second = 300;
                that.flag = true;
                window.clearInterval(interval);
              }
            }, 1000)
          }
        })
      }
    },
    setStorage(p) {
      localStorage.setItem("dalay", p);
      localStorage.setItem("_time", new Date().getTime());
    },
    getStorage() {
      let localDelay = {};
      localDelay.delay = localStorage.getItem("dalay");
      localDelay.sec = localStorage.getItem("_time");
      return localDelay;
    },
    bindEmail() {
      this.$refs.bindForm.validate((valid) => {
        if (valid) {
          checkEmailVerCode({email: this.bindForm.email, verCode: this.bindForm.code, request: 'form', uid: this.uid,}).then(res=>{
            if (res.code==200){
              bindMailbox({email: this.bindForm.email, userId: this.uid, request: 'form', uid: this.uid}).then(res=>{
                if (res.code==200){
                  this.$message.success(res.msg)
                  this.bindForm={email: '', code: ''};
                  this.getBindInfo();
                }else{
                  this.$message.error(mes.msg);
                }
              })
            }else{
              this.$message.error(mes.msg);
            }
          })
        } else {
          return false;
        }
      });
    },
    /*邮箱加密*/
    parseStringToStar(str) {
      let a = str.split('@')[0]
      let b = str.split('@')[1]
      let c = ''
      if (a.length > 5) {
        c = a.substr(0, 3) + '*****' + a.substr(-2)
      } else {
        c = a
      }
      return c + '@' + b
    },
    /*解绑邮箱*/
    UnbindEmail() {
      const h = this.$createElement;
      this.$msgbox({title: '提醒',
        message: h('div', null, [
          h('p', null, '解绑后该邮箱将无法登陆此账号'),
          h('span',null,'请确认您的手机号'),
          h('span',{ style: 'color: #FE273B' },this.bindInfo.mobile),
          h('span',null,'能正常使用')
        ]),
        showCancelButton: true,
        confirmButtonText: '确定解绑',
        cancelButtonText: '取消',
        center: true
      }).then(action => {
        untieMailbox({email: this.bindInfo.email, userId: this.uid, request: 'form', uid: this.uid}).then(res=>{
          if (res.code==200){
            this.$message.success(res.msg);
            this.getBindInfo();
          }else{
            this.$message.error(res.msg);
          }
        })
      });
    },
    /*获取绑定信息*/
    getBindInfo() {
      accountManage({userId: this.uid, request: 'form', uid: this.uid}).then((res) => {
        if (res.code == 200) {
          this.bindInfo = res.content.entity;
        }
      })
    }
  },
  beforeMount() {
    this.uid = JSON.parse(sessionStorage.getItem('loginData')).cid;
    this.getBindInfo();
  }
}
</script>
<style scoped>
.bind-email-container >>> .un-bind-email .el-form--label-top .el-form-item__label {
  padding: 0 0 0px;
}

.bind-email-container >>> .un-bind-email .get-code {
  color: #0067DD;
}

.bind-email-container >>> .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  padding: 10px 20px;
}

.bind-email-container >>> .el-button--danger:hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}
</style>
<style scoped lang="scss">
.bind-email-container {
  background: #ffffff;

  .bind-content {
    padding: 20px;

    .un-bind-email {
      .title {
        margin-block-start: 0px;
        font-size: 16px;
        color: #333333;
      }
    }

    .bind-email {
      .title {
        margin-block-start: 0px;
        margin-block-end: 0px;
        font-size: 14px;
        color: #333333;
        margin-bottom: 5px;
      }

      .bigger-title {
        color: #333333;
        margin-block-start: 0px;
        font-size: 22px;
        font-weight: 200;
      }

      .gray-tips {
        margin-block-start: 0px;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
</style>
<style>
.el-message-box__wrapper .el-button--primary {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
}
</style>